import React, {useRef} from 'react'
import {FieldInput} from '../field-input'
import {Autocomplete, useLoadScript} from '@react-google-maps/api'
import {useFormikContext} from 'formik'
import {useGoogleMaps} from '@frnt/base/providers'

const GOOGLE_MAPS_LIBRARIES: any = ['places']

interface AddressInputFieldProps {
  handleLoad?: (autocomplete: any) => void
  handlePlaceChanged?: () => void
  handleBlur?: (event?: unknown) => void
  handleChange?: (event: any) => void
  componentRestrictions?: any
  name: string
  field: any
  disabled?: boolean
}
export const AddressInputField = ({handleLoad, handlePlaceChanged, handleBlur, handleChange, componentRestrictions, name, disabled, field, ...otherProps}: AddressInputFieldProps) => {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null)
  const {setFieldValue} = useFormikContext()
  const {apiKey} = useGoogleMaps()
  const {isLoaded} = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries: GOOGLE_MAPS_LIBRARIES as any
  })

  if (!isLoaded) {
    return <FieldInput componentType="input" name={name} />
  }
  const handlePlaceChangedInternal: any = (d: any) => {
    if (handlePlaceChanged) {
      handlePlaceChanged()
    } else {
      // set field value with google autocomplete
      const place = autocompleteRef?.current?.getPlace()
      setFieldValue(name, place?.formatted_address)
    }
  }

  return (
    <Autocomplete
      ref={autocompleteRef as any}
      onLoad={(autocomplete: any) => {
        autocompleteRef.current = autocomplete
        if (handleLoad) {
          handleLoad(autocomplete)
        }
      }}
      onPlaceChanged={handlePlaceChangedInternal}
      // componentRestrictions={componentRestrictions}
      fields={['formatted_address', 'address_components']}
      types={['address']}>
      <FieldInput componentType="input" name={name} disabled={disabled} handleBlur={handleBlur as any} handleChange={handleChange} />
    </Autocomplete>
  )
}
